import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {ImportanceLevel} from '@/models/ImportanceLevel'
import DateFieldWidget from '@payroll/date-field-widget/src/DateFieldWidget.vue'
import GridWidget from '@payroll/grid-widget/src/component/GridWidget.vue'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {KeyValuePair, ServiceApi} from '@payroll/optimus-common'
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model'
import * as moment from 'moment'
import Component from 'vue-class-component'
import {Action, Mutation} from 'vuex-class'

export interface CompanyMsg {
  msgText: string
  msgStartDate: Date
  msgEndDate: Date
  importanceLevel: any
  portalType: KeyValuePair
  msgBannerData: string
  msgBannerUrl: string
  msgTextColor: string
  msgFontSize: number
  boldTextFlag: boolean
}

@Component
export default class MngCompanyMessagesComponent extends FeedbackComponent {

  private readonly getPortalTypesPath: string = 'getPortalTypes'
  private readonly getMngCompanyMsgsPath: string = 'getMngCompanyMessages'
  private readonly getMngCompanyMessagesConfig: string = 'getMngCompanyMessagesConfig'
  private readonly createMngCompanyMsgsPath: string = 'createMngCompanyMessage'
  private readonly updateMngCompanyMsgsPathPath: string = 'updateMngCompanyMessage'
  private readonly addBannerToMngCompanyMessage: string = 'addBannerToMngCompanyMessage'

  @Action('getPortalTypes', StoreNamespace.SEARCH) getPortalTypes!: any
  @Mutation('setPortalTypes', StoreNamespace.SEARCH) setPortalTypes!: any

  public portalTypes: KeyValuePair[] = []

  private searchFieldsMsgs: SearchFieldModel[] = []
  private columnsMsgs: GridColumn[] = []
  private isShowInsertUpdateMsgModal: boolean = false
  private MsgObj: CompanyMsg = {} as CompanyMsg
  private searchObject: any
  private updateMode: boolean = false
  private importanceLevelArr: any[] = []
  private rowIdClicked: string = ''
  private bannerFile: File[] = [];
  private originalMsgBannerData: string = '';
  private updatedMsgId: string = ""
  private bannerFlag: boolean = false
  private memberPortalSelected: boolean = false

  mounted() {
    this.getPortalTypes({requestorCallback: this})
    this.getMsgConfig()

    this.initImportanceLevelArr()
    this.initSearchFields()
    this.initColumns()

    this.getMsgGrid({
      pageNumber: 0,
      pageSize: GridWidget.DEFAULT_PAGE_SIZE
    })
  }

  private initSearchFields(): void {
    this.searchFieldsMsgs = []
    if (this.portalTypes.length === 0) {
      return
    }

    this.searchFieldsMsgs.push({
      label: 'portal_type',
      property: 'portalType',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.portalTypes,
      unSelectFirst: true
    })
    this.searchFieldsMsgs.push({
      label: 'start_date',
      property: 'msgStartDate',
      fieldType: FieldType.DATE_FIELD
    })
    this.searchFieldsMsgs.push({
      label: 'end_date',
      property: 'msgEndDate',
      fieldType: FieldType.DATE_FIELD
    })
    this.searchFieldsMsgs.push({
      label: 'msg_text',
      property: 'msgText',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 255,
      advancedOnly: true
    })
    this.searchFieldsMsgs.push({
      label: 'priority',
      property: 'importanceLevel',
      fieldType: FieldType.SELECT_FIELD,
      advancedOnly: true,
      selectOptions: this.importanceLevelArr,
      selectDisplay: 'description',
      unSelectFirst: true
    })
  }

  private initColumns(): void {
    this.columnsMsgs.push({property: 'portalType.description', header: 'portal_type'})
    this.columnsMsgs.push({property: 'msgText', header: 'msg_text'})
    this.columnsMsgs.push({property: 'msgStartDate', header: 'start_date'})
    this.columnsMsgs.push({property: 'msgEndDate', header: 'end_date'})
    this.columnsMsgs.push({property: 'importanceLevel.description', header: 'priority'})
  }

  private initImportanceLevelArr(): void {
    this.importanceLevelArr.push({description: '' + this.$t('low'), value: ImportanceLevel.LOW.toString()})
    this.importanceLevelArr.push({description: '' + this.$t('medium'), value: ImportanceLevel.MEDIUM.toString()})
    this.importanceLevelArr.push({description: '' + this.$t('high'), value: ImportanceLevel.HIGH.toString()})
  }

  private getMsgGrid(searchObject: any): void {
    this.searchObject = searchObject
    new ServiceApi()
      .setToken(this.accessToken)
      .setRequestName(this.getMngCompanyMsgsPath)
      .setRequestBody(searchObject)
      .post(this)
  }

  private getMsgConfig(): void {
    new ServiceApi()
      .setToken(this.accessToken)
      .setRequestName(this.getMngCompanyMessagesConfig)
      .get(this)
  }

  onSuccess(data: any, requestName?: string, message?: string): void {
    switch (requestName) {
      case this.getPortalTypesPath:
        this.setPortalTypes(data)
        this.portalTypes = [...data].filter(
          (portalType: KeyValuePair) => portalType.value == '1' || portalType.value == '2' || portalType.value == '3'
        ).reverse()
        this.initSearchFields()
        break
      case this.getMngCompanyMessagesConfig:
        this.bannerFlag = data.bannerFlag
        break
      case this.getMngCompanyMsgsPath:
        this.$emit('successResults', data)
        break
      case this.createMngCompanyMsgsPath:
      case this.updateMngCompanyMsgsPathPath:
        this.updatedMsgId = data.msgId
        this.saveMsgBannerIfExist()
        break
      case this.addBannerToMngCompanyMessage:
        this.createdUpdatedMsg();
        break
    }
  }

  private onRowClick(row: any): void {
    this.cleanServerErrorMessages()
    this.updateMode = true
    this.rowIdClicked = row.id
    this.MsgObj = {
      msgText: row.msgText,
      msgStartDate: moment(row.msgStartDate, DateFieldWidget.DATE_FORMAT).toDate(),
      msgEndDate: moment(row.msgEndDate, DateFieldWidget.DATE_FORMAT).toDate(),
      importanceLevel: row.importanceLevel,
      portalType: row.portalType,
      msgBannerData: row.bannerDataBase64,
      msgBannerUrl: row.bannerUrl,
      msgTextColor: row.msgTextColor,
      msgFontSize: row.msgFontSize,
      boldTextFlag: row.boldTextFlag
    }

    this.bannerFile = []
    this.updatedMsgId = ""

    this.isShowInsertUpdateMsgModal = true
  }

  private onAddClicked(): void {
    this.cleanServerErrorMessages()
    this.MsgObj = {
      msgText: '',
      msgStartDate: moment().startOf('month').toDate(),
      msgEndDate: moment().endOf('month').toDate(),
      importanceLevel: this.importanceLevelArr[1],
      portalType: this.portalTypes[0],
      msgBannerUrl: "",
      msgBannerData: "",
      msgTextColor: "black",
      msgFontSize: 16,
      boldTextFlag: false
    }
    this.isShowInsertUpdateMsgModal = true
  }

  private onCreateUpdateMsg(): void {


    if (this.updateMode) {
      new ServiceApi()
        .setToken(this.accessToken)
        .setPathVariable(this.rowIdClicked)
        .setRequestName(this.updateMngCompanyMsgsPathPath)
        .setRequestBody(this.MsgObj)
        .put(this)
    } else {
      new ServiceApi()
        .setToken(this.accessToken)
        .setRequestName(this.createMngCompanyMsgsPath)
        .setRequestBody(this.MsgObj)
        .post(this)
    }
  }

  private modalClosed(): void {
    this.cleanServerErrorMessages()
    this.updateMode = false
  }

  private createdUpdatedMsg() {
    this.isShowInsertUpdateMsgModal = false
    const notificationObj = {
      toShow: true,
      message: this.updateMode ? 'msg_updated_succeeded' : 'msg_created_succeeded',
      icon: 'checkCircle',
      secondsToDisappear: 3
    }
    this.$root.$emit('showAlertNotification', notificationObj)

    this.searchObject.pageNumber = 0
    this.getMsgGrid(this.searchObject)

    this.updateMode = false
  }

  onInputFile(files: any[]) {
    this.originalMsgBannerData = this.MsgObj.msgBannerData + ""
    // @ts-ignore
    this.MsgObj.msgBannerData = this.bannerFile[0].blob
  }

  onRemovedAttachmentClicked() {
    if (this.originalMsgBannerData) {
      this.MsgObj.msgBannerData = this.originalMsgBannerData + ""
    }

    this.bannerFile = [];
  }

  private saveMsgBannerIfExist() {

    if (this.bannerFile.length > 0) {
      const formData: FormData = new FormData();
      // @ts-ignore
      formData.append('file', this.bannerFile[0].file)
      formData.append('url', this.MsgObj.msgBannerUrl)
      formData.append('msgId', this.updatedMsgId)

      new ServiceApi()
        .setToken(this.accessToken)
        .setRequestName(this.addBannerToMngCompanyMessage)
        .setFormData(formData)
        .post(this)


    } else {
      this.createdUpdatedMsg()
    }
  }


  getImageSrc(base64Data: string): string {
    if (base64Data.includes("blob")) {
      return base64Data
    }

    return `data:image/png;base64,${base64Data}`;
  }

  private handleMsgTextIsBoldClicked() {
    this.MsgObj.boldTextFlag = !this.MsgObj.boldTextFlag;
  }

  private handleMsgTextColorUpdated(newColor: string) {
    this.MsgObj.msgTextColor = newColor
  }

  private adjustMsgFontSize(change: number): void {
    const beforeChange: number = Number.parseInt(this.MsgObj.msgFontSize + "")
    const newSize = beforeChange + change;

    if (newSize >= 0) {
      this.MsgObj.msgFontSize = newSize;
    } else {
      console.warn('Font size cannot be negative.');
    }
  }

  public handleIncreaseFontSize(): void {
    this.adjustMsgFontSize(1); // Increase font size by 1
  }

  public handleDecreaseFontSize(): void {
    this.adjustMsgFontSize(-1); // Decrease font size by 1
  }

  get displayOfMsgText(): string {
    return this.MsgObj.msgText.replace(/\n/g, '<br>')
  }

  get getOriginalMsgText(): string {
    return this.MsgObj.msgText
  }

  private showMsgText: boolean = true;

  private restMsgText() {
    this.showMsgText = false
    this.MsgObj.msgText = ""
    setTimeout(() => {
      this.showMsgText = true
    }, 50);
  }

  private handlePortalTypeChanged(inputVal: any) {
    const portalType: KeyValuePair = inputVal

    this.memberPortalSelected = portalType.value != "1";
  }
}

